import { createSlice } from '@reduxjs/toolkit';
import { AccountsState } from './state';
import reducers from './reducers';

const initialState: AccountsState = {
  join_info: null,
  isLogin: false,
  refresh: null,
  access: '',
  user: null,
  socialAccounts: null,
  // For join process
  socialAccountData: null,
};

const accounts = createSlice({
  name: 'accounts',
  initialState,
  reducers,
});

export const accountActions = { ...accounts.actions };
export default accounts;
